// import useQuery from "components/customHooks/useQuery";
import orciCareLogo from "assets/header-logo-2.jpg";
// import spryLogo from "assets/spry_movement_pt.png";

const PaymentHeader = ({ resultPage, source, billLogo }) => {
  // let query = useQuery();
  // const src = source || query.get("src");
  return (
    <header className="payemnt-header">
      {/* {src?.toLocaleLowerCase() === "spry" ? (
        <img src={spryLogo} alt="logo" />
      ) : (
        <img src={orciCareLogo} alt="logo" />
      )} */}
      {billLogo ? (
        <img src={billLogo} alt="logo" />
      ) : (
        <img src={orciCareLogo} alt="logo" />
      )}
      {/* {resultPage ? <p className="warning">Do Not Refresh The Page!</p> : null} */}
    </header>
  );
};

export default PaymentHeader;
